import { Box, Typography } from '@mui/material'

interface GambleAwareBadgeProps {
  color?: string
  bgcolor?: string
  fontFamily?: string
}

export function GambleAwareBadge({ color = 'white', bgcolor, fontFamily }: GambleAwareBadgeProps) {
  return (
    <Box
      bgcolor={bgcolor}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box
        component="a"
        href="https://www.begambleaware.org/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          display: 'flex',
          px: 1.5,
          justifyContent: 'center',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            border: `2px solid ${color}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Typography variant="caption" fontWeight="bold" style={{ color, lineHeight: 1 }}>
            18+
          </Typography>
        </Box>
        <Typography variant="body2" fontWeight="bold" style={{ color }} fontFamily={fontFamily}>
          GambleAware
        </Typography>
      </Box>
    </Box>
  )
}
